import { Response } from '@marketplace-web/shared/api-client'

import {
  GetPackageSizesSuggestionResp,
  PackageSizeDto,
  PackageSizeModel,
  PackageSizesResp,
} from '../types/package-size'
import { GetParcelDetailsResp } from '../types/parcel'

export const transformPackageSizeDto = ({
  code,
  custom,
  name,
  description,
  education_text,
  format_description,
  id,
  standard,
  title,
  weight_description,
  image,
}: PackageSizeDto): PackageSizeModel => ({
  code,
  custom,
  name,
  description,
  educationText: education_text,
  formatDescription: format_description,
  id,
  standard,
  title,
  weightDescription: weight_description,
  image,
})

export const transformGetPackageSizesSuggestionResponse = (
  response: Response<GetPackageSizesSuggestionResp>,
) => ({
  packageSizeId: response.package_size_id,
})

export const transformPackageSizesResponse = (response: Response<PackageSizesResp>) => ({
  packageSizes: response.package_sizes.map(transformPackageSizeDto),
  parcelMeasurements: {
    enabled: response.parcel_measurements.enabled,
    suggestion: response.parcel_measurements.suggestion,
  },
})

export const transformGetParcelDetailsResponse = (response: Response<GetParcelDetailsResp>) => ({
  packageSize: response.package_size ? transformPackageSizeDto(response.package_size) : null,
  maxMeasurementsExceeded: response.max_measurements_exceeded,
})
